<div class="d-flex align-self-center align-items-center" [ngClass]="{'large-icon': large}">
  <div *ngIf="showRating && !onlyStars" class="align-self-center">
    <span class="rating">{{rating | number: '1.1-2'}}</span>
  </div>
  <fa-icon [icon]="determineIcon(1)" [styles]="{'color': '#E8BC00'}"></fa-icon>
  <fa-icon *ngIf="!showOneStar" [icon]="determineIcon(2)" [styles]="{'color': '#E8BC00'}"></fa-icon>
  <fa-icon *ngIf="!showOneStar" [icon]="determineIcon(3)" [styles]="{'color': '#E8BC00'}"></fa-icon>
  <fa-icon *ngIf="!showOneStar" [icon]="determineIcon(4)" [styles]="{'color': '#E8BC00'}"></fa-icon>
  <fa-icon *ngIf="!showOneStar" [icon]="determineIcon(5)" [styles]="{'color': '#E8BC00'}"></fa-icon>
</div>
